import useSWR from "swr";
import axios from "axios";

function useLabourers({ shouldFetch = true, page, perPage, sortField, sortOrder, search }) {
  return useSWR(shouldFetch ? [
    `${process.env.REACT_APP_API_URL}/labourers`, page, perPage, sortField, sortOrder, search
  ] : null, async ([url, page, perPage, sortField, sortOrder, search]) => {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (sortField) params.append('sortField', sortField);
    if (sortOrder) params.append('sortOrder', sortOrder);
    if (search) params.append('search', search);

    const { data: { labourers, count } } = await axios.get(`${url}?${params.toString()}`);

    return { labourers, count };
  });
}

export default useLabourers;
